import { RouteConfig } from "vue-router";
import { searchApp } from "./app";
import { searchResultRouteConfig } from "./searchResult/module";

export const searchRouteConfig: RouteConfig = {
  path: searchApp.route,
  component: {
    render(h) {
      return h("router-view", { key: (this as any).$route.fullPath });
    },
  },
  children: [searchResultRouteConfig],
};
